<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    [loading]="loading"
    [width]="SWITCH.IS_SIMPLE_MODE ? '6.08rem' : '7rem'"
    (onHide)="close()">
    <n-header>
        <h1>{{ i18n.title.addClient}}</h1>
        <n-help-link key="nfsAddClient" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifynfsManage" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-checkbox *ngIf="!SWITCH.IS_SIMPLE_MODE && !slideWindow?.showBatch" id="add-client-nfs-share_advanced" style="margin-left: auto;"
            [label]="i18n.label.advance" [(ngModel)]="advanced">
        </n-checkbox>
    </n-header>

    <form [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }">
        <!-- 类型 -->
        <n-form-item [label]="i18n.label.type" [required]="true">
            <n-select #nfsClientTypeSelect
                id="add-client-nfs-share_client_type_dropdown"
                formControlName="type"
                [options]="str.clientTypeOpts"
                (onChange)="onTypeChange($event)">
            </n-select>
            <!-- 网络组情况下，总是显示tip -->
            <n-tip type="info"
                [class.hidden]="!showGuideTip && vm.value.type !== ClientType.net">
                <app-file-system-guide #guide
                    [vstoreId]="vstoreId"
                    [textConfigs]="configGuide.textConfigs"
                    [guideItems]="configGuide.guideItems"
                    (onEnd)="showGuideTip=$event">{{ vm.value.type === ClientType.net ? i18n.tip.dnsConfigureTip : '' }}
                </app-file-system-guide>
            </n-tip>
        </n-form-item>

        <!-- 主机 -->
        <n-form-item *ngIf="vm.value.type === ClientType.host" [label]="i18n.label.clients" required="true">
            <n-multi-input id="add-client-nfs-share_host_name"
                style="width: 3rem;"
                formControlName="hostName"
                [nTooltip]="i18n.tip.addClientTip1"
                [seperator]="[' ', ';']"
                [nTooltipTrigger]="'focus'"
                [nTooltipPlacement]="'left'">
            </n-multi-input>
        </n-form-item>
        <!-- 网络组 -->
        <n-form-item *ngIf="vm.value.type === ClientType.net" [label]="i18n.label.clients" required="true">
            <n-multi-input id="add-client-nfs-share_net_name"
                style="width: 3rem;"
                formControlName="netName"
                [nTooltip]="i18n.tip.addClientTip2"
                [seperator]="[' ', ';']"
                [nTooltipTrigger]="'focus'"
                [nTooltipPlacement]="'left'">
            </n-multi-input>
        </n-form-item>

        <!-- UNIX权限级别 -->
        <n-form-item [label]="i18n.label.unixPermissionLab" [required]="true">
            <n-select id="add-client-nfs-share_permission_dropdown"
                formControlName="unixPermission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
        <!-- Kerberos5权限级别 -->
        <n-form-item [label]="i18n.label.kerberos5PermissionLab" [required]="true" *ngIf="!SWITCH.IS_SIMPLE_MODE && !ProductConfig.isHideKerberos">
            <n-select id="add-client-nfs-share-kerberos5-permission"
                formControlName="kerberos5Permission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
        <!-- Kerberos5i权限级别 -->
        <n-form-item [label]="i18n.label.kerberos5iPermissionLab" [required]="true" *ngIf="!SWITCH.IS_SIMPLE_MODE && !ProductConfig.isHideKerberos">
            <n-select id="add-client-nfs-share-kerberos5i-permission"
                formControlName="kerberos5iPermission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
        <!-- Kerberos5p权限级别 -->
        <n-form-item [label]="i18n.label.kerberos5pPermissionLab" [required]="true" *ngIf="!SWITCH.IS_SIMPLE_MODE && !ProductConfig.isHideKerberos">
            <n-select id="add-client-nfs-share-kerberos5p-permission"
                formControlName="kerberos5pPermission"
                [options]="permissionLevelOpts">
            </n-select>
        </n-form-item>
        <!-- root权限限制 -->
        <n-form-item [label]="i18n.label.root_squash"
            [helpContent]="i18n.tip.root_squash"
            [required]="true">
            <n-radio-group id="add-client-nfs-share_root_squash"
                formControlName="root_squash">
                <n-radio *ngFor="let option of str.root_squashOpts"
                    [id]="'add-client-nfs-share_root_squash_'+ option.value"
                    [value]="option.value">
                    {{option.label}}
                </n-radio>
            </n-radio-group>
        </n-form-item>

        <n-collapse-list id="simple-advance-setting-collapse"
            [title]="i18n.label.advancedSettingTitle"
            *ngIf="SWITCH.IS_SIMPLE_MODE"
            class="simple-advance-setting-collapse">
            <ng-container [ngTemplateOutlet]="advanceTemplate">
            </ng-container>
        </n-collapse-list>

        <ng-container *ngIf="!SWITCH.IS_SIMPLE_MODE && advanced"
            [ngTemplateOutlet]="advanceTemplate">
        </ng-container>

        <!-- 高级选项 -->
        <ng-template #advanceTemplate>
            <!-- 权限限制 -->
            <n-form-item [label]="i18n.label.all_squash" [helpContent]="i18n.tip.all_squash">
                <n-radio-group id="add-client-nfs-share_all_squash" formControlName="all_squash">
                    <n-radio *ngFor="let option of str.all_squashOpts"
                        [id]="'add-client-nfs-share_all_squash_'+ option.value" [value]="option.value">
                        {{option.label}}
                    </n-radio>
                </n-radio-group>
            </n-form-item>

            <!-- 源端口校验限制 -->
            <n-form-item [label]="i18n.label.secure" [helpContent]="i18n.tip.secure">
                <n-radio-group id="add-client-nfs-share_secure" formControlName="secure">
                    <n-radio *ngFor="let option of str.secureOpts" [id]="'add-client-nfs-share_secure_'+ option.value"
                        [value]="option.value">
                        {{option.label}}
                    </n-radio>
                </n-radio-group>
            </n-form-item>

            <!-- 匿名用户ID -->
            <n-form-item [label]="i18n.label.anonymousUserId"
                [helpContent]="i18n.tip.anonymousUserId">
                <n-spinner id="add-client-nfs-anonymous-user-id"
                    style="width: 1.7rem;"
                    [onlyInput]="true"
                    [rangeTip]="true"
                    [min]="ANONYMOUS_ID_RANGE.MIN"
                    [max]="ANONYMOUS_ID_RANGE.MAX"
                    formControlName="anonymousUserId">
                </n-spinner>
            </n-form-item>
        </ng-template>
    </form>

    <n-footer>
        <button id="add-client-nfs-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="add-client-nfs-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
